export default "__VITE_ASSET__Cy07Tf8m__"